import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function saveLabelPrint(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  const doc = {
    ...data,
    doc_type: DocType.LABEL_PRINT,
    effective_date: util.toStringDate(data.effective_date),
    name: util.toStringText(data.name),
    notes: util.toBoolean(data.notes),
  };

  doc.label_print_lines = data.label_print_lines.map((line) => ({
    ...line,
    count: util.toNumber(line.count),
  }));

  return common.saveDoc(app, {
    doc,
    user,
    source: data,
  });
}

export function deleteLabelPrint(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.LABEL_PRINT,
  });
}

export function fetchLabelPrintById(app, params) {
  const { id } = params;
  const docType = DocType.LABEL_PRINT;
  return common.getDoc(app, { id, docType });
}

export async function printLabelPrint(app, id) {
  const service = app.service(`label_print/print/${id}`);
  const data = await service.create();
  return data;
}

export async function labelPrintFileDownload(app, path) {
  const service = common.getPdfService(app);
  const data = service.get('download', { path }, undefined, { responseType: 'blob' });
  return data;
}
